"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactPdf = require("react-pdf");
var _Text = _interopRequireDefault(require("./Text"));
var _Button = _interopRequireDefault(require("./Button"));
var _Loader = _interopRequireDefault(require("./Loader"));
require("react-pdf/dist/esm/Page/TextLayer.css");
require("react-pdf/dist/esm/Page/AnnotationLayer.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// these must be imported to fix a bug where dead space and extra random characters are renderered at the bottom of the pdf
_reactPdf.pdfjs.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(_reactPdf.pdfjs.version, "/pdf.worker.js");
/**
 * @param props
 * @returns {*}
 * @constructor
 */
function PDFViewer(props) {
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    pages = _useState2[0],
    setNumPages = _useState2[1];
  var _useState3 = (0, _react.useState)(1),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    pageNumber = _useState4[0],
    setPageNumber = _useState4[1]; // setting 1 to show first page

  /**
   * @param pages
   */
  var onDocumentLoadSuccess = function onDocumentLoadSuccess(_ref) {
    var numPages = _ref.numPages;
    setNumPages(numPages);
    setPageNumber(1);
  };

  /**
   * @param offset
   */
  var changePage = function changePage(offset) {
    setPageNumber(function (prevPageNumber) {
      return prevPageNumber + offset;
    });
  };
  var pdf = props.pdf,
    width = props.width,
    customStyle = props.customStyle;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread({
      maxWidth: '100%',
      height: 'auto',
      minHeight: '50vh',
      marginLeft: 'auto',
      marginRight: 'auto'
    }, customStyle)
  }, props.onDownload && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    transparent: true,
    onClick: props.onDownload,
    customStyle: {
      display: 'block',
      marginLeft: 'auto',
      marginBottom: 1.25
    }
  }, "DOWNLOAD"), /*#__PURE__*/_react["default"].createElement(_reactPdf.Document, {
    file: pdf,
    onLoadSuccess: onDocumentLoadSuccess,
    loading: /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
      noGif: true
    })
  }, /*#__PURE__*/_react["default"].createElement(_reactPdf.Page, {
    pageNumber: pageNumber,
    width: width || 900
  })), pages > 1 && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: 20
    }
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    disabled: pageNumber <= 1,
    onClick: function onClick() {
      return changePage(-1);
    }
  }, "Previous"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    align: "center"
  }, "Page ", pageNumber || (pages ? 1 : "--"), " of ", pages || "--"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    disabled: pageNumber >= pages,
    onClick: function onClick() {
      return changePage(1);
    }
  }, "Next")));
}
var _default = exports["default"] = PDFViewer;